/*
 * Copyright (c) 2023 Omnicell. All rights reserved.
 *
 * This program contains proprietary, trade secret information of
 * Omnicell. and may not be copied, reproduced or reverse engineered
 * in any way without the prior written permission of Omnicell.
 */

export const primaryBrandColorVarName = '--primary-brand-color';
export const secondaryBrandColorVarName = '--secondary-brand-color';
export const tertiaryBrandColorVarName = '--tertiary-brand-color';
export const primaryBrandFontColorVarName = '--primary-brand-font-color';
